// Philippines Employee Benefits Policy Details Mock Data

export const InsuranceCompanyOptions = [
  { label: "Malayan Insurance", value: "Malayan Insurance" },
  { label: "PGA Sompo", value: "PGA Sompo" },
  { label: "AXA Philippines", value: "AXA Philippines" },
  { label: "Charter Ping An", value: "Charter Ping An" },
  { label: "FPG Insurance", value: "FPG Insurance" },
  { label: "Pioneer Insurance", value: "Pioneer Insurance" },
  { label: "Standard Insurance", value: "Standard Insurance" },
  { label: "Maxicare", value: "Maxicare" },
  { label: "Medicard Philippines", value: "Medicard Philippines" },
  { label: "Intellicare", value: "Intellicare" },
];

export const InsurancePolicyTypes = [
  { label: "Group Medical/HMO", value: "GroupMedical" },
  { label: "Group Life", value: "GroupLife" },
  { label: "Group Personal Accident", value: "GroupPA" },
  { label: "Group Hospitalization", value: "GroupHospitalization" },
  { label: "Group Dental", value: "GroupDental" },
  { label: "Group Critical Illness", value: "GroupCriticalIllness" },
];

export const InsurancePolicycontainer = [
  { label: "Maxicare", value: "Maxicare", sumInsured: "₱500,000" },
  { label: "Medicard Philippines", value: "Medicard Philippines", sumInsured: "₱750,000" },
  { label: "Intellicare", value: "Intellicare", sumInsured: "₱1,000,000" },
  { label: "AXA Philippines", value: "AXA Philippines", sumInsured: "₱2,000,000" },
];

export const pesoTypes = [
  { label: "PHP", value: "PHP" },
  { label: "USD", value: "USD" },
];

export const PremiumCurrency = [
  { label: "PHP", value: "PHP" },
  { label: "USD", value: "USD" },
];
export const InstallmentType = [
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Semi-Annual", value: "Semi-Annual" },
  { label: "Annual", value: "Annual" },
];

export const PolicyTypes = [
  { label: "Cash", value: "Cash" },
  { label: "Check", value: "Check" },
  { label: "Bank Transfer", value: "Bank Transfer" },
  { label: "Credit Card", value: "Credit Card" },
  { label: "GCash", value: "GCash" },
  { label: "PayMaya", value: "PayMaya" },

];

export const AccountCodes = [
  { label: "ACME001", value: "ACME001" },
  { label: "XYZ123", value: "XYZ123" },
  { label: "BLU567", value: "BLU567" },
  { label: "CORP789", value: "CORP789" },
  { label: "MAGIC456", value: "MAGIC456" },
  { label: "FAB789", value: "FAB789" },
];

export const VehicleBrands = [
  { label: "Top Management/C-Suite", value: "Top Management/C-Suite" },
  { label: "Senior Managment", value: "Senior Managment" },
  { label: "Middle Managment", value: "Middle Managment" },
  { label: "Junior/Staff Level", value: "Junior/Staff Level" },
  { label: "Field/Operations Staff", value: "Field/Operations Staff" },
];

export const ModelYears = [
  { label: "Domestic", value: "Domestic" },
  { label: "Nationwide", value: "Nationwide" },
  { label: "Regional", value: "Regional" },
  { label: "Worldwide", value: "Worldwide" }, 
];

export const VehicleModels = [
  { label: "3 Series", value: "3 Series" },
  { label: "Rav4", value: "Rav4" },
  { label: "Mustang", value: "Mustang" },
  { label: "CR-V", value: "CR-V" },
];


export const ModelVariants = [
  { label: "X5", value: "X5" },
  { label: "Camry", value: "Camry" },
  { label: "Fusion", value: "Fusion" },
  { label: "Accord", value: "Accord" },
];


export const VehicleColors = [
  { label: "Quantum Blue", value: "QuantumBlue" },
  { label: "Solar Flare Red", value: "SolarFlareRed" },
  { label: "Galactic Silver", value: "GalacticSilver" },
  { label: "Nebula Black", value: "NebulaBlack" },
  { label: "Stellar White", value: "StellarWhite" },
  { label: "Velocity Green", value: "VelocityGreen" },
];
